// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../resources/profile-photo.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-container, .sidebar-container-sm-screen{
    background-color: var(--app-color-3);
    width: 150px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: fixed;
}

.sidebar-container-sm-screen {
    width: 100%;
    transition: width 0.1s ease-in-out;
}

.sidebar-parent {
    background-color: black;
    display: flex;
    justify-content: center;
    padding-top: 50px;
    padding-bottom: 30px;
}

.sidebar-profile-photo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 80px;
    width: 80px; 
    background-size: cover;
    border-radius: 50%;
    background-position: center;
    box-shadow: 0px 2px 0px 1px var(--app-color-4);
    transition: transform 0.2s ease-in-out;
}

.sidebar-profile-photo:hover {
    transform: scale(1.1);
    transition: transform 0.2s ease-in-out;
    cursor: pointer;
}

.sidebar-profile-name, .sidebar-profile-web-dev {
    text-align: center;
    color: white;
    padding: 5px 0;
}

.sidebar-profile-name {
    padding-top: 18px;
    padding-bottom: 3px;
    font-size: 20px;
}

.sidebar-profile-web-dev {
    font-size: 10px;
}

.sidebar-about {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    height: 1300px;
}

.sidebar-about-list {
    list-style: none;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 5px 5px;
}

.sidebar-about-list li {
    margin: 0 auto;
}

li a {
    color: white;
    text-decoration: none;
    text-align: center;
}

li a:hover {
    color: var(--app-color-4);
}

.sidebar-about-list li {
    display: flex;
}

.sidebar-links-container {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: auto 10px;
    display: flex;
    text-align: center;
}

.sidebar-link {
    padding: 0 4px;
    margin: 0 5px;
    height: 25px;
    width: 25px;
    transition: transform 0.2s ease-in-out;
}

.sidebar-links a {
    text-decoration: none;
    color: white;
}

.sidebar-links a:hover{
    color: var(--app-color-4);
}

.sidebar-link:hover {
    transform: scale(1.1);
}

@media screen and (max-width: 1300px) {
    .sidebar-container {
        transition: width 0.1s ease-in-out;
        visibility: hidden;
    }
}`, "",{"version":3,"sources":["webpack://./src/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,yDAAwD;IACxD,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,kCAAkC;QAClC,kBAAkB;IACtB;AACJ","sourcesContent":[".sidebar-container, .sidebar-container-sm-screen{\r\n    background-color: var(--app-color-3);\r\n    width: 150px;\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    position: fixed;\r\n}\r\n\r\n.sidebar-container-sm-screen {\r\n    width: 100%;\r\n    transition: width 0.1s ease-in-out;\r\n}\r\n\r\n.sidebar-parent {\r\n    background-color: black;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding-top: 50px;\r\n    padding-bottom: 30px;\r\n}\r\n\r\n.sidebar-profile-photo {\r\n    background-image: url('../resources/profile-photo.jpeg');\r\n    height: 80px;\r\n    width: 80px; \r\n    background-size: cover;\r\n    border-radius: 50%;\r\n    background-position: center;\r\n    box-shadow: 0px 2px 0px 1px var(--app-color-4);\r\n    transition: transform 0.2s ease-in-out;\r\n}\r\n\r\n.sidebar-profile-photo:hover {\r\n    transform: scale(1.1);\r\n    transition: transform 0.2s ease-in-out;\r\n    cursor: pointer;\r\n}\r\n\r\n.sidebar-profile-name, .sidebar-profile-web-dev {\r\n    text-align: center;\r\n    color: white;\r\n    padding: 5px 0;\r\n}\r\n\r\n.sidebar-profile-name {\r\n    padding-top: 18px;\r\n    padding-bottom: 3px;\r\n    font-size: 20px;\r\n}\r\n\r\n.sidebar-profile-web-dev {\r\n    font-size: 10px;\r\n}\r\n\r\n.sidebar-about {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n    height: 1300px;\r\n}\r\n\r\n.sidebar-about-list {\r\n    list-style: none;\r\n    text-align: center;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-around;\r\n    padding: 5px 5px;\r\n}\r\n\r\n.sidebar-about-list li {\r\n    margin: 0 auto;\r\n}\r\n\r\nli a {\r\n    color: white;\r\n    text-decoration: none;\r\n    text-align: center;\r\n}\r\n\r\nli a:hover {\r\n    color: var(--app-color-4);\r\n}\r\n\r\n.sidebar-about-list li {\r\n    display: flex;\r\n}\r\n\r\n.sidebar-links-container {\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    margin: auto 10px;\r\n    display: flex;\r\n    text-align: center;\r\n}\r\n\r\n.sidebar-link {\r\n    padding: 0 4px;\r\n    margin: 0 5px;\r\n    height: 25px;\r\n    width: 25px;\r\n    transition: transform 0.2s ease-in-out;\r\n}\r\n\r\n.sidebar-links a {\r\n    text-decoration: none;\r\n    color: white;\r\n}\r\n\r\n.sidebar-links a:hover{\r\n    color: var(--app-color-4);\r\n}\r\n\r\n.sidebar-link:hover {\r\n    transform: scale(1.1);\r\n}\r\n\r\n@media screen and (max-width: 1300px) {\r\n    .sidebar-container {\r\n        transition: width 0.1s ease-in-out;\r\n        visibility: hidden;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
